import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'tipoBulto'
})
export class TipoBultoPipe implements PipeTransform {

  transform(value: string, unidCaja?: number, unidFrac?: number): string | null {
    if (value === 'U') {
      return 'Unid';
    } else if (value === 'C') {
      return 'Caj(' + unidCaja?.toString() + ')';
    } else if (value === 'F') {
      return 'Fra(' + unidFrac?.toString() + ')';
    } else if (value === 'K') {
      return 'Kilos';
    }
    return null;
  }

}
